import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const eraser: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="m7-1 2.625-3h-6L1-1Zm7.922-8.422c.07.18.094.367.062.563a.9.9 0 0 1-.234.515l-7 8Q7.45.001 7 0H1Q.7.001.453-.156a1.1 1.1 0 0 1-.36-.438.9.9 0 0 1-.077-.547 1.04 1.04 0 0 1 .234-.515l7-8A.95.95 0 0 1 8-10h6c.195 0 .379.055.547.156q.246.159.375.422m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(-.002 10)"
    />
  ),
  svgProps: {
    height: "10",
    width: "14.996",
  }
};